import React from 'react';

//handle admin dashboard option click
const handleAdminDbClick = () => {
  window.open('/admin-dashboard', '_blank');
};

// Admin Dashboard menu option
const AdminDashboardOption = () => {
  return (
    <div
      className={`tw-py-1 tw-w-full tw-border-solid tw-border-grey-200 tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-pb-3 tw-font-medium tw-text-grey-700 tw-cursor-pointer`}
      onClick={handleAdminDbClick}
      role='button'
      tabIndex={0}
    >
      Admin Dashboard
    </div>
  );
};

export default AdminDashboardOption;
